/* eslint-disable import/prefer-default-export */
export const handleError = (axiosError) => {
  console.log('Raw Error', axiosError.response)
  return ['Something went wrong']
}
